//import store from "../../store";
const vereinRoutes = [
  {
    path: "/Verein",
    component: () =>
      import(
        /*webpackChunkName: 'component-homepage' */ "@/pages/Verein.vue"
      ), 
      
  },
];

export default vereinRoutes;
